import React from "react";
import { Mutation } from "react-apollo";
import { Icon, message } from "antd";
import { Storage } from "aws-amplify";
import async from "async";

import ContentEditable from "./ContentEditable";
import CreateComment from "../../GraphQL/Mutation/CreateComment";

class MessengerFooter extends React.Component {
  state = {
    html: ""
  };

  handleUpload = (files, stripedHtml, orderId, mutate) => {
    const { user } = this.props;
    const storageOpts = {
      bucket: "as-comments",
      region: "us-east-1",
      identityId: orderId
    };

    // this.setState({ uploading: true });

    async.map(
      files,
      (file, callback) => {
        console.log("Processing file " + file);

        Storage.put(`${user.id}/${file.name}`, file, {
          ...storageOpts,
          level: "private"
        })
          .then(result => {
            callback(null, { ...result, ...storageOpts });
          })
          .catch(err => {
            message.error(err);
            callback(err);
          });
      },
      (err, results) => {
        if (err) {
          console.log(err);
          message.error(err);
        } else {
          console.log(results);
          message.success("Archivos cargados correctamente!");
          mutate({
            variables: {
              orderId,
              message: stripedHtml || null,
              files: results
            }
          })
            .then(result => {
              message.success("Mensaje enviado!");
              console.log(result);
            })
            .catch(err => {
              console.log(err);
              message.error(err.message);
            });
        }
        // this.setState({ uploading: false, fileList: [] });
      }
    );
  };

  handleSubmit = async (mutate, e) => {
    const { orderId, files, handleClearFiles, setIsNewMessage } = this.props;
    const { html } = this.state;

    e.preventDefault();

    var stripedHtml = html.replace(/<[^>]+>/g, "\n").trim();
    // var parsed = stripedHtml.replace(/[\r\n]+/g, "\n");
    // var decodedStripedHtml = he.decode(stripedHtml);

    if (!stripedHtml && !(files && files.length)) {
      return;
    }

    if (files && files.length) {
      await this.handleUpload(files, stripedHtml, orderId, mutate);
    } else {
      mutate({
        variables: {
          orderId,
          message: stripedHtml
        }
      })
        .then(result => console.log(result))
        .catch(err => console.log(err));
    }

    setIsNewMessage();
    this.setState({ html: "" });
    handleClearFiles();
  };

  handleChange = evt => {
    this.setState({ html: evt.target.value });
  };

  handleEnter = (mutate, e) => {
    if (e.nativeEvent.charCode === 13 && !e.nativeEvent.shiftKey) {
      this.handleSubmit(mutate, e);
    }
  };

  renderSelectedFiles = files => {
    return (
      <div className="messenger-files">
        {files.map(file => (
          <div key={file.name} className="messenger-file">
            <div className="messenger-file__icon">
              {file.type.split("/")[0] === "image" ? (
                <img width={45} src={file.preview} alt={file.name} />
              ) : (
                <Icon type="file-text" />
              )}
            </div>
            <div className="messenger-file__content">
              <div className="messenger-file__content-top">
                <div className="file-type">{file.name.split(".").pop()}</div>
                <Icon
                  type="close-circle-o"
                  style={{
                    fontSize: 14,
                    cursor: "pointer"
                  }}
                  onClick={() => this.props.onRemove(file)}
                />
              </div>

              <div className="messenger-file__content-name">{file.name}</div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  render() {
    const { dropzoneRef, files } = this.props;
    return (
      <Mutation mutation={CreateComment}>
        {mutate => (
          <React.Fragment>
            <div className="messenger-footer__input">
              {files && files.length ? this.renderSelectedFiles(files) : null}
              <div className="messenger-footer__input-text">
                <div
                  className="messenger-placeholder"
                  style={
                    this.state.html
                      ? { visibility: "hidden" }
                      : { visibility: "visible" }
                  }
                >
                  Escribe un mensaje aquí
                </div>
                <ContentEditable
                  html={this.state.html} // innerHTML of the editable div
                  disabled={false} // use true to disable edition
                  onChange={this.handleChange} // handle innerHTML change
                  onKeyPress={e => this.handleEnter(mutate, e)}
                  className="messenger-input"
                  spellCheck="true"
                />
              </div>
            </div>
            <div className="messenger-footer__toolbar">
              <Icon
                type="paper-clip"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dropzoneRef.open();
                }}
              />
              <button
                className="messenger-footer__toolbar-send-btn"
                onClick={e => this.handleSubmit(mutate, e)}
                disabled={!this.state.html && !(files && files.length)}
              >
                <Icon type="caret-right" />
              </button>
            </div>
          </React.Fragment>
        )}
      </Mutation>
    );
  }
}

export default MessengerFooter;



// WEBPACK FOOTER //
// ./src/Components/Comments/MessengerFooter.js